import React from 'react';
import { Routes, Route } from 'react-router-dom'
import AccessDenied from '../Components/AccessDenied';
import CreateForm from '../Components/CreateForm';
import CreateTeam from '../Components/CreateTeam';
import LandingPage from '../Components/LandingPage';
import NewOrg from '../Components/NewOrg';
import { Assign } from '../Pages/Assign';
import { Dashboard } from '../Pages/Dashboard';
import { ViewForm } from '../Pages/ViewForm';
import CreateAdmin from '../Components/CreateAdmin';
import SuperAdmin from "../Components/SuperAdmin";
import ChangeRole from '../Components/ChangeRole';
import { Result } from '../Pages/Result';
import { EmployeeViewForm } from '../Pages/EmployeeViewForm';
import { FillForm } from '../Pages/FillForm';
import { MyForms } from '../Pages/MyForms';
import Analytics from '../Pages/Analytics';
import UpdateMember from '../Components/UpdateMember';



const AllRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/createform" element={<CreateForm />} />
                <Route path="/dashboard/" element={<Dashboard />} />
                <Route path="/accessdenied" element={<AccessDenied />} />
                <Route path="/:formId/viewform" element={<ViewForm />} />
                <Route path="/employeeviewform" element={<EmployeeViewForm />} />
                <Route path='/:formId/fillform' element={<FillForm />} />
                <Route path='/:formId/responses' element={<Result />} />
                <Route path="/assign" element={<Assign />} />
                <Route path="/createteam" element={<CreateTeam />} />
                <Route path="/update/:teamId" element={<UpdateMember />} />
                <Route path="/createadmin" element={<CreateAdmin />} />
                <Route path="/superadmin" element={<SuperAdmin />} />
                <Route path="/createorg" element={<NewOrg />} />
                <Route path="/changerole" element={<ChangeRole />} />
                <Route path="/myforms" element={<MyForms />} />
                <Route path="/:formId/analytics" element={<Analytics />} />
            </Routes>
        </>
    )
}

export default AllRoutes
